import { initialState, StorePageState } from './selectors';
import * as actions from './actions';
import { actions as authActions } from '@ui/store/auth';

export default (
  state: StorePageState = initialState,
  action: actions.CitiesAction,
) => {
  switch (action.type) {
    case actions.STORE_ACTIONS.REQUESTED: {
      const { payload } = action as actions.StoreRequested;
      return { ...state, storeId: payload.storeId, loading: true };
    }

    case actions.STORE_ACTIONS.SUCCEEDED: {
      const {
        payload: { store },
      } = action as actions.StoreSucceeded;
      return {
        ...state,
        store,
        loading: false,
        historyCollections: store.collections,
      };
    }

    case actions.UPDATE_COMMENT_SUCCESS: {
      const { payload } = action as actions.CommentSuccess;
      return {
        ...state,
        store: {
          ...state.store,
          comment: payload.comment,
        },
      };
    }

    case actions.STORE_ACTIONS.FAILED: {
      const { error } = action as actions.StoreFailed;
      return { ...state, error, loading: false };
    }

    case actions.SAVE_REQUEST_ACTIONS.REQUESTED: {
      return { ...state, loading: true };
    }

    case actions.SAVE_REQUEST_ACTIONS.SUCCEEDED: {
      return { ...state, loading: false };
    }

    case actions.SAVE_REQUEST_ACTIONS.FAILED: {
      return { ...state, loading: false };
    }

    case authActions.AUTH_ACTIONS.LOGOUT_SUCCEEDED: {
      return { ...state, ...initialState };
    }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/scenes/Store/services/reducer.ts